import { connect } from 'react-redux';
import PaywallComparison from '@/components/Paywalls/PaywallComparison';
import { paywallSelector } from '@/selectors';

const mapStateToProps = (state) => {
  return paywallSelector(state);
};
export default connect(mapStateToProps)(PaywallComparison);
